import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { WebLayout } from '@/components/layout'

const LandingPageLazy = lazy(() =>
  import('@/features/landing').then((m) => ({ default: m.LandingPage }))
)

export const Route = createFileRoute('/')({
  component: () => (
    <WebLayout>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <LandingPageLazy />
      </Suspense>
    </WebLayout>
  ),
})
